<template>
  <div class="home">
    <img alt="Vue logo" src="https://ik.imagekit.io/farel14/kodok_sarjana_logo_8MUYOLNXx.png">
    <!-- <h1>From player to player</h1> -->
    <!-- <h1 class="lead">Build | Wiki | Shop</h1> -->
    <h1 id="tagline">-Yugioh Community Site-</h1>
    <!-- <button @click.prevent=""></button> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  methods: {
    // tembakTwitter () {
    //   this.$dispatch.
    // }
  }
}
</script>

<style scoped>
.home{
  max-height: 100%;
}
#tagline{
  font-family:Verdana, Geneva, Tahoma, sans-serif;
}
</style>
